import { useMemo } from 'react';

import { MAILROOM_NATIVE_APP_ID, NativeAppStatus } from 'utils/nativeApps';

import { useFeatureFlag } from './useFeatureFlag';
import { useOpQuery } from './useOpQuery';
import { useFeatureGate } from './useFeatureGate';

const MAILROOM_FEATURE_CODE = 'mailroom';

export const useIsMailroomEnabled = ({ orgId }: { orgId: number }) => {
  const { hasFeature: hasMailroomFeature } = useFeatureGate(
    MAILROOM_FEATURE_CODE,
    orgId,
  );

  const { data: orgNativeApps } = useOpQuery({
    apiEndpointName: 'listOrgNativeApps',
    parameters: [orgId],
    select: (heliumResponse) => heliumResponse.json.data ?? [],
  });

  const hasMailroomNativeApp = orgNativeApps?.some(
    (app) =>
      app.nativeAppId === MAILROOM_NATIVE_APP_ID &&
      app.status === NativeAppStatus.Active,
  );

  // TODO - Hide mailroom in table for now. Update when no longer determined by a feature flag.
  const { value: isMailroomEnabledFF } = useFeatureFlag<boolean>(
    'ENABLE_MAILROOM',
    orgId,
  );

  const isMailroomEnabled = useMemo(() => {
    return hasMailroomNativeApp || isMailroomEnabledFF || hasMailroomFeature;
  }, [hasMailroomFeature, hasMailroomNativeApp, isMailroomEnabledFF]);

  return isMailroomEnabled;
};
